import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { DeliveriesService } from './deliveries.service';
import { EventsService } from './events.service';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  message = '';
  messages = [];
  packages: any = []
  noNetwork: boolean = true
  filter: any = {};
  token: any;
  packageStatus: any = [
    {
      Level: 1,
      Remarks: "",
      Status:
        "We have found you a driver! Please settle your delivery fee",
      Time: ""
    },
    {
      Level: 2,
      Remarks: "",
      Status: "Payment successful! Delivery request will start at scheduled pickup time",
      Time: ""
    },
    { Level: 3, Remarks: "", Status: "The driver is on his way to your pickup location", Time: "" }, //actualPickupTime
    { Level: 4, Remarks: "", Status: "Your driver has arrived and will be loading your package into the vehicle", Time: "" }, //actualLoadingTime
    { Level: 5, Remarks: "", Status: "The driver is in transit for delivery. Driver is in his way to your drop off location.", Time: "" }, //actualEnrouteTime
    {
      Level: 6,
      Remarks: "",
      Status: "The driver has arrived at your drop off location with your package", Time: "" //actualUnloadingTime
    },
    {
      Level: 7,
      Remarks: "",
      Status: "Package has been delivered", Time: "" //actualCompletionTime
    },
  ];

  constructor(private socket: Socket,
    private events: EventsService,
    private deliverysrvc: DeliveriesService) { }

  initTracking() {
    // // console.log("init tracking")
    this.socket.connect();
    this.socket.emit('setUserName', 'JhonDoe002');
    this.setUserActivityEvent();

    this.socket.fromEvent('message').subscribe(info => {
      // this.messages.push(info);
      console.log("driver location", info);
      this.validateTracking(info)
    });
  }

  setUserActivityEvent() {
    this.socket.fromEvent('usersActivity').subscribe((data: any) => {
      if (data.event === 'chatLeft') {
        // // // console.log(data.user + ' Left the Chat Room');
      } else {
        // // // console.log(data.user + ' Joined the Chat Room');
      }
    });
  }

  getPackages() {
    // // console.log("get every open of the app in prog jobs");
    this.filter.deliveryStatus = "inProgress";
    this.deliverysrvc.getAll(this.filter, localStorage.getItem('authToken'))
      .then(async (data) => {
        let packages = data["data"] || [];
        let newpackages = [];
        // // console.log("packages", packages);

        // Original Code
        for (let i = 0; i < packages.length; i++) {

          let newpackageStatus = [];
          let refpackageStatus = this.packageStatus;
          let currentstatus = 0;

          if (packages[i].deliveryStatus != "inProgress.driverAccepted") {
            if (
              packages[i].deliveryStatus == "inProgress.driverAccepted" &&
              packages[i].transactionAmountInfo.status == undefined
            ) {
              currentstatus = 1;
            }

            if (
              packages[i].deliveryStatus == "inProgress.driverAccepted" &&
              packages[i].transactionAmountInfo.status == "success"
            ) {
              currentstatus = 2;
            }

            if (packages[i].deliveryStatus == "inProgress.driverForPickup") {
              currentstatus = 3;
            }

            if (packages[i].deliveryStatus == "inProgress.driverLoading") {
              currentstatus = 4;
            }

            if (packages[i].deliveryStatus == "inProgress.driverEnRoute") {
              currentstatus = 5;
            }

            if (packages[i].deliveryStatus == "inProgress.driverForDropoff") {
              currentstatus = 6;
            }


            for (let psi = 0; psi < this.packageStatus.length; psi++) {

              if (refpackageStatus[psi].Level === currentstatus) {
                refpackageStatus[psi].Remarks = await "Ongoing";
              }
              else if (refpackageStatus[psi].Level < currentstatus) {
                refpackageStatus[psi].Remarks = await "Done";
              }
              else {
                refpackageStatus[psi].Remarks = await "Pending";
              }

              await newpackageStatus.push(
                {
                  Level: refpackageStatus[psi].Level,
                  Remarks: refpackageStatus[psi].Remarks,
                  Status: refpackageStatus[psi].Status,
                  Time: (
                    refpackageStatus[psi].Level == 3 ? packages[i].custom.actualPickupTime :
                      refpackageStatus[psi].Level == 4 ? packages[i].custom.actualLoadingTime :
                        refpackageStatus[psi].Level == 5 ? packages[i].custom.actualEnrouteTime :
                          refpackageStatus[psi].Level == 6 ? packages[i].custom.actualUnloadingTime : null),
                }
              );
            }
            packages[i].packageStatus = await newpackageStatus;
            newpackages.push(packages[i]);
          }
          newpackageStatus = [];
          refpackageStatus = [];
        }
        // // console.log(newpackages);

        let sortedPackages = newpackages.sort((a, b) => {
          return b.pickupDate - a.pickupDate;
        });

        // // console.log("sortedPackages", sortedPackages);

        this.packages = sortedPackages || [];
        // // console.log("this.packages", this.packages);
        this.initJobRequest(this.packages)
      });
  }

  initJobRequest(inprogress) {
    if (localStorage.getItem('jobRequestInProgress')) {
      let inprog = JSON.parse(localStorage.getItem('jobRequestInProgress'))
      if (inprog) {
        // // console.log("i have already data", inprog);
        let removeCompletedJobs: any = []
        inprogress.forEach(element => {
          // // console.log("inprogress", element);
          inprog.forEach(subelement => {
            // // console.log("inprog", subelement);
            if (subelement.deliveryId == element.deliveryId && subelement.deliveryStatus == element.deliveryStatus) {
              removeCompletedJobs.push(subelement)
            }
          });
        });

        if (inprogress[0] && inprogress[0].deliveryId) {
          let validateNewJob = _.filter(removeCompletedJobs, { 'deliveryId': inprogress[0].deliveryId, 'deliveryStatus': inprogress[0].deliveryStatus });
          let tempList = _.reject(removeCompletedJobs, { 'deliveryId': inprogress[0].deliveryId, 'deliveryStatus': inprogress[0].deliveryStatus });


          // // console.log("tempList", tempList);

          // // console.log("validateNewJob", validateNewJob);
          // // console.log("removeCompletedJobs", removeCompletedJobs);

          if (validateNewJob.length > 0) {
            let newList = [].concat(tempList, inprogress);
            // // console.log("no need to add inprograddress", newList);
            localStorage.setItem('jobRequestInProgress', JSON.stringify(newList))
          } else {
            let newList = [].concat(removeCompletedJobs, inprogress);
            // // console.log("newList", newList);
            localStorage.setItem('jobRequestInProgress', JSON.stringify(newList))
          }
        }
      } else {
        localStorage.setItem('jobRequestInProgress', inprogress)
      }
    }
  }

  validateTracking(info) {
    let jobrequestTracking = JSON.parse(localStorage.getItem('jobRequestInProgress'))
    if (jobrequestTracking) {
      var receiverKeyword = info.info.receiver.toLowerCase();
      let InProgJob = _.filter(jobrequestTracking, { 'deliveryId': info.info.requestId, 'clientId': receiverKeyword });
      let newInProgJob = _.reject(jobrequestTracking, { 'deliveryId': info.info.requestId })
      let tracking: any = {}

      if (info.info.driverstatus == "4") {
        let newList = newInProgJob ? newInProgJob : []
        localStorage.setItem('jobRequestInProgress', JSON.stringify(newList))
      }

      if (InProgJob.length > 0) {
        // // // console.log("im in progress need to update the map", info);
        if (localStorage.getItem('trackingRequest')) {
          let trackings = JSON.parse(localStorage.getItem('trackingRequest'))
          if (trackings) {
            // Original Code ---------
            let tempList = _.reject(trackings, { 'requestId': info.info.requestId, 'receiver': receiverKeyword });
            let newList = [].concat(tempList, info);
            // // console.log("update list need to update the marker in map", newList);
            localStorage.setItem('trackingRequest', JSON.stringify(newList))
            // Original Code ---------
            // Testing Code ---------
            // Testing Code ---------
          } else {
            // // // console.log("i dont have any data yet");
            localStorage.setItem('trackingRequest', JSON.stringify([info]))
          }
          let tracking = {
            tracking: true,
            requestId: info.info.requestId
          }
          this.events.publishData(tracking)
        }
      } else {
        localStorage.setItem('trackingRequest', JSON.stringify([info]))
        let tracking = {
          tracking: true,
          requestId: info.info.requestId
        }
        this.events.publishData(tracking)
      }
      // // // console.log("InProgJob", InProgJob);
    }
  }

}
